module.exports = __webpack_public_path__ + "img/equip.3330b813.jpg";